export default __webpack_public_path__ + "static/media/vehicle-group.07e17ac1.svg";